import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar";
import Layout from "../Layout";
import "../../index.css";
import { gql, useMutation } from "@apollo/client";
import Loader from "../../Loader";
import LabledInput from "../CommonComponents/LabledInput";
import LabeledSwitch from "../CommonComponents/CustomSwitch";
import { useNavigate } from "react-router-dom";
import BackButton from "../CommonComponents/BackButton";

const ADD_INVENTORY_CATEGORY = gql`
  mutation addInventoryInventory($data: InventoryCategoryInput!) {
    addInventoryCategory(data: $data) {
      status
      message
    }
  }
`;
const EDIT_INVENTORY_CATEGORY = gql`
  mutation updateInventoryCategory($data: UpdateInventoryCategoryInput!) {
    updateInventoryCategory(data: $data) {
      status
      message
    }
  }
`;

const AddInventoryCategory = ({ editFormData, setEditForm }) => {
  const [addInventoryCategory, { addLoading, addError }] = useMutation(
    ADD_INVENTORY_CATEGORY
  );
  const [editInventoryCategory, { editLoading, editError }] = useMutation(
    EDIT_INVENTORY_CATEGORY
  );

  const [name, setName] = useState(editFormData ? editFormData.name : "");
  const [abbr, setAbbr] = useState(editFormData ? editFormData.abbr : "");
  const [parts, setParts] = useState(editFormData ? editFormData.parts : 0);
  const [minStock, setMinStock] = useState(
    editFormData ? editFormData.minStock : 0
  );
  const [isFetched, setIsFetched] = useState(false);
  const [canDecrease, setCanDecrease] = useState(
    editFormData ? editFormData.canDecrease : false
  );
  const [isScanRequired, setIsScanRequired] = useState(
    editFormData ? editFormData.isScanRequired : false
  );
  const [minStockAdmin, setMinStockAdmin] = useState(
    editFormData ? editFormData.minStockAdmin : null
  );
  const [allowManualCount, setAllowManualCount] = useState(
    editFormData ? editFormData.allowManualCount : false
  );
  const [addOncePerBooking, setAddOncePerBooking] = useState(
    editFormData ? !!editFormData.addOncePerBooking : false
  );
  const [cost, setCost] = useState(editFormData ? editFormData.cost : "");
  const [extraPrice, setExtraPrice] = useState(
    editFormData ? editFormData.extraPrice : ""
  );
  const navigate = useNavigate();

  useEffect(() => {
    try {
      setIsFetched(true);
    } catch (err) {
      console.log(err);
    }
  }, []);

  const handleNameChange = (e) => {
    setName(e.target.value);
  };
  const handleAbbrChange = (e) => {
    setAbbr(e.target.value);
  };

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (isSubmitting) return; // Prevent double clicks
    
    if (!name || !abbr || !minStock) {
      alert("Name, Abbreviation, and Min Stock are required fields.");
      return;
    }
    
    setIsSubmitting(true);
    let finalDataObj = {};
    finalDataObj.name = name;
    finalDataObj.abbr = abbr;
    if (canDecrease) {
      finalDataObj.parts = parseInt(parts);
    }
    finalDataObj.canDecrease = canDecrease;
    finalDataObj.minStock = parseInt(minStock);
    finalDataObj.isScanRequired = isScanRequired;
    finalDataObj.minStockAdmin = parseInt(minStockAdmin);
    finalDataObj.allowManualCount = allowManualCount;
    finalDataObj.addOncePerBooking = addOncePerBooking;
    if (cost !== "" && cost !== null) finalDataObj.cost = parseFloat(cost);
    if (extraPrice !== "" && extraPrice !== null) {
      finalDataObj.extraPrice = parseFloat(extraPrice);
    }
    if (editFormData) {
      finalDataObj.id = editFormData.id;
      editInventoryCategory({
        variables: {
          data: finalDataObj,
        },
      })
        .then((res) => {
          if (res.data.updateInventoryCategory.status === "SUCCESS") {
            window.location = "/admin/inventory-category-table";
          } else {
            alert(res.data.updateInventoryCategory.message);
            setIsSubmitting(false);
          }
        })
        .catch((err) => {
          console.log(err);
          alert("An error occurred while updating the category.");
          setIsSubmitting(false);
        });
      return;
    } else {
      addInventoryCategory({
        variables: {
          data: finalDataObj,
        },
      })
        .then((res) => {
          if (res.data.addInventoryCategory.status === "SUCCESS") {
            window.location = "/admin/inventory-category-table";
            // navigate("/admin/sub-category");
          } else {
            setIsSubmitting(false);
          }
        })
        .catch((err) => {
          console.log(err);
          setIsSubmitting(false);
        });
    }
  };

  // const subCategoryClass = subCategory ? "text-white" : " text-[#9A9A9A]";
  if (addLoading) return <Loader />; // Show Loader while loading;
  return (
    <>
      <div className="min-h-screen flex">
        <Sidebar />
        <Layout>
          {isFetched && (
            <div className="flex flex-col py-3 px-2 space-y-5">
              <BackButton
                onClick={() =>
                  editFormData ? setEditForm(false) : navigate(-1)
                }
              />

              <h3 className="text-[#FBB033] font-be-jost-pro font-bold text-2xl">
                {editFormData ? "Edit" : "Add"} Inventory Category
              </h3>
              <div className="w-full flex flex-col space-y-8">
                <LabledInput
                  type="text"
                  label={"Name"}
                  onChange={(e) => handleNameChange(e)}
                  value={name}
                  placeholder={"Enter Category Name"}
                />

                <LabledInput
                  type="text"
                  label={"Abbreviation"}
                  onChange={(e) => handleAbbrChange(e)}
                  value={abbr}
                  placeholder={"Write Abbreviation"}
                />
                <LabeledSwitch
                  checked={canDecrease}
                  onChange={(e) => setCanDecrease(e)}
                  label={"Can Decrease?"}
                  leftLabel="No"
                  rightLabel="Yes"
                />

                <LabeledSwitch
                  checked={isScanRequired}
                  onChange={(e) => setIsScanRequired(e)}
                  label={"Scan Required?"}
                  leftLabel="No"
                  rightLabel="Yes"
                />

                <LabeledSwitch
                  checked={allowManualCount}
                  onChange={(e) => setAllowManualCount(e)}
                  label={
                    "Employee Can Add Extra? (manual entry, exceed recipe default, or add ad-hoc when not in a service's recipe)"
                  }
                  leftLabel="No"
                  rightLabel="Yes"
                />

                <LabeledSwitch
                  checked={addOncePerBooking}
                  onChange={(e) => setAddOncePerBooking(e)}
                  label={
                    "Add Once Per Booking? (e.g. disposable packet - added to every booking at 1, employee changes it per person)"
                  }
                  leftLabel="No"
                  rightLabel="Yes"
                />

                {canDecrease && (
                  <LabledInput
                    type="number"
                    label={"Parts"}
                    onChange={(e) => setParts(e.target.value)}
                    value={parts}
                    placeholder={"Enter parts..."}
                  />
                )}

                <LabledInput
                  type="number"
                  label={"Min Stock"}
                  onChange={(e) => setMinStock(e.target.value)}
                  value={minStock}
                  placeholder={"Enter min stock in parts..."}
                />
                <LabledInput
                  type="number"
                  label={"Min Stock Admin"}
                  onChange={(e) => setMinStockAdmin(e.target.value)}
                  value={minStockAdmin}
                  placeholder={"Enter min stock in quantity..."}
                />

                <LabledInput
                  type="number"
                  label={"Cost (per unit)"}
                  onChange={(e) => setCost(e.target.value)}
                  value={cost}
                  placeholder={"Used to value what an employee is holding"}
                />

                {allowManualCount && (
                  <LabledInput
                    type="number"
                    label={"Extra Price (per unit beyond default)"}
                    onChange={(e) => setExtraPrice(e.target.value)}
                    value={extraPrice}
                    placeholder={"Charged/tracked for amounts beyond the recipe default"}
                  />
                )}

                <div className="flex items-center justify-center">
                  <button
                    className="bg-[#FBB034] text-[#202125] py-2 px-6 rounded-md font-poppins text-sm font-bold"
                    onClick={handleSubmit}
                  >
                    {editFormData ? "Update" : "Add"} Inventory Category
                  </button>
                </div>
              </div>
            </div>
          )}
        </Layout>
      </div>
    </>
  );
};

export default AddInventoryCategory;
